export const projects = [
    {
        id: 'dissolve-shader',
        thumbnail: './lab2.jpg',
        images: ['./lab2.jpg'],
        descriptions: [
            `A Three.js demo that applies a custom dissolve effect to 3D meshes
                        by injecting shader code directly into a MeshStandardMaterial.`,
        ],
        tech: 'React · TypeScript · Three.js · WebGL · GLSL',
        links: [
            { url: 'https://dissolve-shader.vercel.app/', text: 'Visit Website' },
            { url: 'https://github.com/ryan-tzw/dissolve-shader', text: 'View GitHub Repo' },
        ],
    },
    {
        id: 'audio-visualiser',
        thumbnail: './lab1.jpg',
        images: ['./lab1.jpg'],
        descriptions: [
            `A React-based audio visualiser that captures live microphone input with
                        the Web Audio API and renders it in real time as custom shader-driven
                        graphics using WebGL via React Three Fiber and Three.js`,
        ],
        tech: 'React · JavaScript · Three.js · WebGL · GLSL · Web Audio API',
        links: [{ url: 'https://audio-visualiser-one.vercel.app/', text: 'Visit Website' }],
    },
    {
        id: 'semantic-search',
        thumbnail: './search1.png',
        images: ['./search1.png', './search2.png'],
        descriptions: [
            `I developed a lightweight semantic search engine in Python that indexes
            arXiv abstracts. It fetches paper metadata, preprocesses each abstract,
            generates local embeddings with SentenceTransformers, and stores them in
            a persistent ChromaDB vector store. You can then interactively query the
            most relevant papers via a simple CLI.`,
        ],
        tech: 'Python · NLP · SentenceTransformers · ChromaDB',
        links: [{ url: 'https://github.com/ryan-tzw/semantic-search', text: 'View GitHub Repo' }],
    },
    {
        id: 'mnist-project',
        thumbnail: './mnist1.png',
        images: ['./mnist1.png', './mnist2.png', './mnist3.png', './mnist4.png'],
        descriptions: [
            `I implemented a simple 2-layer neural network from scratch in Python to
            classify handwritten digits from the MNIST dataset, which achieved 88%
            accuracy in just 1000 iterations.`,

            `The workflow loads and preprocesses CSV data with pandas, normalizes
            pixel values, and uses NumPy to build and train the model, implementing
            ReLU activations, softmax outputs, forward/backward propagation, and
            gradient descent.`,
        ],
        tech: 'Python · NumPy · Pandas · Matplotlib',
        links: null, // no button if null
    },
    {
        id: 'basic-site',
        thumbnail: './site1.jpg',
        images: ['./site1.jpg'],
        descriptions: [
            `The site that you're currently viewing!
            Originally just a simple portfolio, but has since been
            expanded with more features like a modal and image carousel.`,

            `As I added more projects, the HTML boilerplate became cumbersome,
            so I refactored it into a script to dynamically generate the projects and modals.`,

            `I've grown and learned a lot since I first built this site,
            so I plan to build a new one in the future, likely with Three.js and React.
            Stay tuned!`,
        ],
        tech: 'HTML · CSS · JavaScript',
        links: [
            { url: 'https://www.ryantzw.dev/', text: 'Visit Website' },
            { url: 'https://github.com/ryan-tzw/basic-site', text: 'View GitHub Repo' },
        ],
    },
    {
        id: '3d-portfolio',
        thumbnail: './site2.jpg',
        images: ['./site2.jpg'],
        descriptions: [
            `This is a 3D portfolio website that I built using Three.js and React.
            It features an immersive 3D virtual workspace scene, with this
            current website you're browsing embedded in the computer monitor in the scene.`,
        ],
        tech: 'React · TypeScript · Three.js · WebGL · GLSL · React Three Fiber',
        links: [
            { url: 'https://3d.ryantzw.dev/', text: 'Visit Website' },
            { url: 'https://github.com/ryan-tzw/portfolio-2025', text: 'View GitHub Repo' },
        ],
    },
    {
        id: 'laptop-render',
        thumbnail: './site3.jpg',
        images: ['./site3.jpg'],
        descriptions: [
            `This is a demo of a laptop 3D model rendered in the browser using
            React Three Fiber and Three.js. It embeds this current website
            you're browsing inside the laptop screen, and allows you to rotate
            the laptop around in 3D space.`,
        ],
        tech: 'React · JavaScript · Three.js · WebGL · React Three Fiber',
        links: [
            { url: 'https://laptop-render.vercel.app/', text: 'Visit Website' },
            { url: 'https://github.com/ryan-tzw/laptop-render', text: 'View GitHub Repo' },
        ],
    },
    {
        id: 'animations-gallery',
        thumbnail: './animations.png',
        images: ['./animations.png'],
        descriptions: [
            `Built with React, Tailwind and Framer Motion.
            This is a personal collection of UI micro-interactions and effects I’ve created,
            with inspiration drawn from various developers and open-source examples online.`,

            `I'll be continuously adding more animations to this library as I create them. `,
        ],
        tech: 'React · TypeScript · Framer Motion · Tailwind CSS',
        links: [
            { url: 'https://animations.ryantzw.dev/', text: 'Visit Website' },
            { url: 'https://github.com/ryan-tzw/animation-gallery', text: 'View GitHub Repo' },
        ],
    },
    {
        id: 'github-contributions',
        thumbnail: './github.png',
        images: ['./github.png'],
        descriptions: [
            `This is a simple React app that visualises contributions of a GitHub repository,
            using TanStack Query + Axios to fetch the data from the GitHub API,
            and Recharts, a D3.js-based charting library, to render the data.`,

            `Might expand this in the future to include more features.`,
        ],
        tech: 'React · TypeScript · Recharts · TanStack Query · Axios',
        links: [
            { url: 'https://commits.ryantzw.dev/', text: 'Visit Website' },
            {
                url: 'https://github.com/ryan-tzw/github-commit-visualiser',
                text: 'View GitHub Repo',
            },
        ],
    },
    {
        id: 'wayfare',
        thumbnail: './wayfare1.jpg',
        images: ['./wayfare1.jpg'],
        descriptions: [
            `A hotel booking website for an academic project.
            Built with React, TypeScript and the Mantine UI library, with a custom
            3D hero section using Three.js, React Three Fiber, and custom GLSL shaders.`,

            `This was my first experience building a full-stack application as
            part of a large team project (8 people), and I learned a lot from it.
            Too much to talk about in this little modal, so check out the GitHub repo for more details!`,
        ],
        tech: `React · TypeScript · Mantine UI · Three.js · and more!`,
        links: [
            { url: 'https://esc-fe.ryanteozw.workers.dev/', text: 'Visit Website' },
            { url: 'https://github.com/Term-5-CSD-ESC-Ascenda-BNB/web', text: 'View GitHub Repo' },
        ],
    },
]
